import { PromotionInfoComboBoxModel } from '../promotion-info-combo-box.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

/**
 * プロモーション情報リストを取得する
 *
 * @export API通信成功時の処理
 * @class GetPromotionInfoListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetPromotionInfoListService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private model: PromotionInfoComboBoxModel;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param {PromotionInfoBoxModel} model
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetPromotionInfoListService
   */
  execute(model: PromotionInfoComboBoxModel, successFunc: Function = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('KYMW02getPromotionInfoList', null);
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPromotionInfoListService
   */
  success(data: any) {
    this.model.updateCodeList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
